import React from 'react';
export const OutOfStockMessage = ({ as: MessageComponent = 'p', testId = 'store-out-of-stock-message', children, ...otherProps }) => {
    return (React.createElement(MessageComponent, Object.assign({ "data-out-of-stock-message": true, "data-testid": testId }, otherProps), children));
};
//# sourceMappingURL=OutOfStockMessage.js.map